import * as actionTypes from "./actionTypes";
import * as actions from "store/actions/index";
import { updateObject } from "../utility";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { saveUploadInfo } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";

export const uploadFormState = (formState) => {
  return {
    type: actionTypes.UPLOAD_FORM_STATE,
    payload: formState
  }
}

export const uploadFileStart = () => {
  return {
    type: actionTypes.UPLOAD_FILE_START
  };
};

export const uploadFileSuccess = () => {
  return {
    type: actionTypes.UPLOAD_FILE_SUCCESS
  };
};

export const uploadFileFail = error => {
  return {
    type: actionTypes.UPLOAD_FILE_FAIL,
    error: error
  };
};

export const uploadFileAborted = error => {
  return {
    type: actionTypes.UPLOAD_FILE_ABORTED,
    error: error
  };
};

export const uploadFileProgress = pcObj => {
  return {
    type: actionTypes.UPLOAD_FILE_PROGRESS,
    pcObj: pcObj
  };
};

export const uploadSetState = () => {
  return {
    type: actionTypes.UPLOAD_SET_STATE
  };
};

export const uploadSaveUploadedData = (uploadedObj) => {
  return {
    type: actionTypes.UPLOAD_SAVE_UPLOADEDDATA,
    payload: uploadedObj
  }
}

export const uploadImportFileStart = () => {
  return {
    type: actionTypes.UPLOAD_IMPORT_FILE_START
  };
};

export const uploadImportFileSuccess = () => {
  return {
    type: actionTypes.UPLOAD_IMPORT_FILE_SUCCESS
  };
};

export const uploadImportFileFail = error => {
  return {
    type: actionTypes.UPLOAD_IMPORT_FILE_FAIL,
    error: error
  };
};

export const uploadEditClipStart = () => {
  return {
    type: actionTypes.UPLOAD_EDIT_CLIP_START
  };
};

export const uploadEditClipSuccess = () => {
  return {
    type: actionTypes.UPLOAD_EDIT_CLIP_SUCCESS
  };
};

export const uploadEditClipFail = error => {
  return {
    type: actionTypes.UPLOAD_EDIT_CLIP_FAIL,
    error: error
  };
};

export const uploadProjectAddClipStart = () => {
  return {
    type: actionTypes.UPLOAD_PROJECT_ADD_CLIP_START
  };
};

export const uploadProjectAddClipSuccess = () => {
  return {
    type: actionTypes.UPLOAD_PROJECT_ADD_CLIP_SUCCESS
  };
};

export const uploadProjectAddClipFail = error => {
  return {
    type: actionTypes.UPLOAD_PROJECT_ADD_CLIP_FAIL,
    error: error
  };
};

export const uploadRoomAddClipSuccess = () => {
  return {
    type: actionTypes.UPLOAD_ROOM_ADD_CLIP_SUCCESS
  };
};

export const uploadRoomAddClipFail = error => {
  return {
    type: actionTypes.UPLOAD_ROOM_ADD_CLIP_FAIL,
    error: error
  };
};


/*
* FUNCTION: getStatusProgress
*/
export function getStatusProgress(dispatch, file, counter, startActionTime, uploadMessageId) {
  let getUploadState = async function () {
    let uploadState = await window.flow.getUploadState();
    if (!uploadState.aborted) {
      var serverpc = uploadState.pc;

      if (uploadState.pcfile === file.name) {
        let actionTime;
        if (startActionTime > 0)
          actionTime = Date.now() - startActionTime;
        else actionTime = 0;
        var pcObj = updateObject({}, { id: counter, fileId: file.fileId, filename: file.name, uploading: serverpc, actionTime, uploadMessageId });
        dispatch(uploadFileProgress(pcObj));
      }
    }
  };
  getUploadState();
};

export function checkActionTimeout(dispatch, startActionTime, timerId) {
  if (startActionTime > 0) {
    let time = Date.now() - startActionTime;
    if (DataUtil.checkTimeout(time)) {
      dispatch(uploadImportFileFail());
      let timeOut = DataUtil.getCurrentDayTimestamp();
      dispatch(actions.setCustomUploadInfo({ [`${timeOut}.ServerConnectionError`]: "Server Connection Error like timeout, logout, etc.", "isLoading": false }));
      clearInterval(timerId);
    }
  }
}

// export async function startImportFile(dispatch, localfile, importObj) {
//   let startActionTime = Date.now();
//   let importRes = await window.flow.importFile(localfile, importObj);
//   if (!importRes.success) dispatch(uploadImportFileFail());
//   if (importRes.clipid) startActionTime = 0;

//   return startActionTime;
// }


export async function startImportFile(dispatch, infoCounter, localfile, importObj) {
  let startActionTime = Date.now();
  try {
    let importRes = await window.flow.importFile(localfile, importObj);
    saveUploadInfo(dispatch, importRes, infoCounter, 'ImportFileStatus');
    if (!importRes.success) dispatch(uploadImportFileFail());
    if (importRes.clipid) startActionTime = 0;

  } catch (error) {
    console.log("LAMTEST ImportFileError", error);
    saveUploadInfo(dispatch, error, infoCounter, 'ImportFileStatus');
  }

  return startActionTime;
}

export function updateMetadata(obj, metadata, len, id) {
  if ((obj.appId === CustomTypes.MASTER_UPLOAD_FORM)) {
    return metadata;
  }
  if (len >= 2) {
    let newTitle = DataUtil.changeTitleByAppId(metadata, id);
    return { ...metadata, ...newTitle };
  }
  return metadata;
}

export function uploadSendEmail(dispatch, infoCounter, obj, clipId) {
  if (obj.sendEmail && obj.sendEmail === 1) {
    saveUploadInfo(dispatch, "Starting", infoCounter, 'SendEmail');
    dispatch(actions.sendEmail(DataUtil.sendMessageEmail(clipId)));
  }
}
/*
* FUNCTION: uploadFile
*/

export function uploadFile(obj) {
  return (dispatch, getState) => {
    let metadata = DataUtil.getMetadata(obj);
    let files = [...obj.selectedObjects];
    let len = files.length;
    let counter = 0;
    let timerId;
    let file;
    let isFirst = true;
    let firtClipId;
    let startActionTime;
    let uploadMessageId = "CustomMsgUploading";
    let infoCounter = 1;
    if (getState().customData.customUploadInfo) {
      const { lastUploadCount } = getState().customData.customUploadInfo;
      if (lastUploadCount) infoCounter = lastUploadCount + 1;
    }
    saveUploadInfo(dispatch, "Starting", infoCounter, 'Upload');
    saveUploadInfo(dispatch, metadata, "", 'Metadata');
    let startUpload = async function () {
      file = files.shift();
      uploadMessageId = "CustomMsgUploading";
      let currentTime = DataUtil.getCurrentDayTimestamp;
      saveUploadInfo(dispatch, file.name, infoCounter, 'UploadFileStart');
      saveUploadInfo(dispatch, file.file.size, infoCounter, 'UploadFilesize');
      window.flow.uploadFileWithCancel(file.file).promise.then(res => {
        saveUploadInfo(dispatch, "success", infoCounter, 'UploadFileStatus');
        let startImport = async function () {
          let uploadState = await window.flow.getUploadState();
          if (!uploadState.aborted) {
            dispatch(uploadImportFileStart());
            let fileMetadata = updateMetadata(obj, metadata, len, file.fileId);
            if (res.localfile) {
              uploadMessageId = "CustomMsgImporting";
              saveUploadInfo(dispatch, res.localfile, infoCounter, 'ImportFileStart');
              if (obj.oneClip && !isFirst && firtClipId)
                startActionTime = startImportFile(dispatch, infoCounter, res.localfile, { mode: "add", id: firtClipId });
              if ((obj.appId === CustomTypes.MASTER_UPLOAD_FORM) && obj.masterClipId) {
                saveUploadInfo(dispatch, metadata.tags, infoCounter, 'metadataTags');
                startActionTime = startImportFile(dispatch, infoCounter, res.localfile, { mode: "add", id: obj.masterClipId, tags: metadata.tags });
              }
              if (((obj.oneClip && isFirst) || (!obj.oneClip)) && (obj.appId !== CustomTypes.MASTER_UPLOAD_FORM)) {
                startActionTime = Date.now();
                try {
                  let importRes = await window.flow.importFile(res.localfile);
                  if (importRes) saveUploadInfo(dispatch, importRes, infoCounter, 'ImportFileStatus');
                  if (importRes.clipid) {
                    uploadSendEmail(dispatch, infoCounter, obj, importRes.clipid);
                    saveUploadInfo(dispatch, importRes.clipid, infoCounter, 'EditClip');
                    try {
                      let editRes = await window.flow.editClip(importRes.clipid, fileMetadata);
                      if (editRes && editRes.data && editRes.data.metadata && editRes.data.metadata.fields) {
                        saveUploadInfo(dispatch, "success", infoCounter, 'EditClipStatus');
                        saveUploadInfo(dispatch, editRes.data.metadata.fields, infoCounter, 'EditClipFields');
                      }
                    } catch (err) {
                      saveUploadInfo(dispatch, err, infoCounter, 'EditClipStatus');
                    }
                    if (obj.oneClip) {
                      firtClipId = importRes.clipid;
                      isFirst = false;
                    }
                    if (obj.project) {
                      uploadMessageId = "CustomMsgAddIntoProject";
                      saveUploadInfo(dispatch, obj.project, infoCounter, 'AddToProject');
                      try {
                        let addProjectRes = await window.flow.projectAddClip(obj.project, importRes.clipid);
                        if (addProjectRes) saveUploadInfo(dispatch, "success", infoCounter, 'AddToProjectStatus');
                      } catch (e) {
                        saveUploadInfo(dispatch, e, infoCounter, 'AddToProjectStatus');
                      }
                    }
                    if (obj.room) {
                      uploadMessageId = "CustomMsgAddIntoRoom";
                      saveUploadInfo(dispatch, obj.room, infoCounter, 'AddToRoom');
                      try {
                        let addRoomRes = await window.flow.projectAddClip(obj.room, importRes.clipid);
                        if (addRoomRes) saveUploadInfo(dispatch, "success", infoCounter, 'AddToRoomStatus');
                      } catch (e) {
                        saveUploadInfo(dispatch, e, infoCounter, 'AddToRoomStatus');
                      }
                    }
                    startActionTime = 0;
                  }
                } catch (error) {
                  saveUploadInfo(dispatch, error, infoCounter, 'ImportFileStatus');
                }
              }
            }
            if (files.length > 0) {
              counter++;
              infoCounter++;
              startUpload();
            } else {
              window.clearInterval(timerId);
              dispatch(uploadFileSuccess());
              dispatch(actions.setCustomUploadInfo({ [`${currentTime()}.UploadFiles`]: "done", "lastUploadCount": infoCounter }));
            }
          } else {
            window.clearInterval(timerId);
          }
        }
        startImport();
      })
        .catch(error => {
          saveUploadInfo(dispatch, error, infoCounter, 'UploadFileError');
          window.clearInterval(timerId);
          dispatch(uploadFileFail("uploadFileFail"));
        });
    };

    startUpload();
    timerId = window.setInterval(() => {
      getStatusProgress(dispatch, file, counter, startActionTime, uploadMessageId);
      checkActionTimeout(dispatch, startActionTime, timerId);
    }, 100);
  };
}

export function uploadCancel() {
  let cancelTime = DataUtil.getCurrentDayTimestamp();

  return dispatch => {
    dispatch(actions.setCustomUploadInfo({ [`${cancelTime}.UploadFileCancel`]: "Cancelled", "isLoading": false }));
    window.flow.cancelUpload();
    dispatch(uploadFileAborted());
  }
}
